var map = {
	"./doc__ko__id_doc.png": "026f",
	"./doc__ko__passport.png": "939e",
	"./doc__ru__id_doc.png": "9d8b",
	"./doc__ru__passport.png": "331e",
	"./doc__uz__id_doc.png": "9fbf",
	"./doc__uz__passport.png": "9633"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";